import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProjectIntermediateResultModel, ScaleMeasureDefinitionModel } from '../../../../../hub_schema/hubTypes';

@Component({
  selector: 'app-intermediate-result-target-panel',
  templateUrl: './intermediate-result-target-panel.component.html',
  styleUrl: './intermediate-result-target-panel.component.scss',
  standalone: false
})
export class IntermediateResultTargetPanelComponent {

    @Input()
    public isForIrWizard: boolean = false;

    @Input()
    public intermediateResult: ProjectIntermediateResultModel;

    @Input()
    public targetForm: FormGroup;

    @Input()
    public unitName: string | undefined;

    // #region Scale Measures

    @Input()
    public isScaleMeasureEditingInProgress?: boolean = false;

    public get isScaleMeasure(): boolean {
        if (this.isForIrWizard) {
            return this.isScaleMeasureEditingInProgress;
        }
        else {
            return this.intermediateResult?.scaleMeasureDefinitions!.length > 0;
        }
    }

    private getScaleDefinitions(): ScaleMeasureDefinitionModel[] {
        if (this.isForIrWizard) {
            return this.currentScaleDefinitions;
        }
        return this.intermediateResult.scaleMeasureDefinitions!;
    }

    @Input()
    public currentScaleDefinitions: any[];

    // #endregion Scale Measures

    public getValidationErrorMessages(formControlName: string): string {
        const formControl = this.targetForm!.controls[formControlName];

        if (!formControl.touched) {
            return '';
        }

        if (formControl.errors) {
            const errorMessages: string[] = [];

            for (const key of Object.keys(formControl.errors)) {
                if (key == 'required') {
                    errorMessages.push(key);
                }
                else if (key === 'min' || key === 'max') {
                    errorMessages.push('Value must be 1-5')
                }
                else {
                    errorMessages.push(formControl.errors[key]);
                }
            }
            return errorMessages.join(', ');
        }

        return '';
    }

}
